import { render } from "./App.vue?vue&type=template&id=3a69541c&bindings={\"message\":\"data\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./App.vue?vue&type=style&index=0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script